const withTreks = 'trips/treks';
const withLodge = 'lodgings/lodges';
const withTheme = 'themes';
const withPlace = 'places';
const withUser = 'users';
const withPayment = 'payments';
const withAlbums = 'albums';
// const withAuth = 'auth';

const endpoints = {
  auth: {
    login: `${withUser}/login`,
    signup: `${withUser}/register`,
    changePassword: `${withUser}/changepassword`,
    activateAccount: token => `${withUser}/verify/${token}`,
    resendVerificationMail: `${withUser}/verify/resend`,
  },

  treks: {
    my: `${withTreks}/my`,
    all: {
      withRegion: region => `${withTreks}?region=${region}&per_page=20&page=1`,
      withOutRegion: `${withTreks}`,
    },
    bookLodge: (trekId, dayNum, lodgeId) =>
      `${withTreks}/${trekId}/days/${dayNum}/attach/${lodgeId}`,
    addToTrekDay: (trekId, dayNum) => `${withTreks}/${trekId}/days/${dayNum}`,
    reviews: trekId => `reviews/trips/${trekId}/comments`,
    reply: (trekId, commentId) =>
      `reviews/trips/${trekId}/comments/${commentId}`,
    ratings: trekId => `reviews/trips/${trekId}/ratings`,
    editTrekData: trekId => `${withTreks}/${trekId}`,
    forkTrek: trekId => `${withTreks}/${trekId}/fork`,
    preferences: trekId => `${withTreks}/${trekId}/preferences`,
    elevationProfile: trekId => `${withTreks}/${trekId}/elevation_profile`,
    booking: trekId => `${withTreks}/${trekId}/bookings`,
    getInvoices: () => 'trek-invoices',
    getForkedTreks: id =>
      `${withTreks}?parent=${id}&newmeth=1&starting_price__gt=0`,
    freeze: trekId => `${withTreks}/${trekId}/freeze`,
    overviewData: id => `${withTreks}/${id}`,
    albums: id => `${withAlbums}/trips/${id}`,
    trekCoverImages: trekId => `${withTreks}/${trekId}/cover_image`,
    // albums: id => 'trek-albums',withTreks
  },

  place: {
    listings: {
      // withRegion: (region, pageNo) =>
      // `${withPlace}/localities?region=${region}&per_page=20&page=${pageNo}`,
      // withoutRegion: pageNo => `${withPlace}/localities?&per_page=20&page=${pageNo}`,

      withRegion: region => `${withPlace}/localities?region=${region}`,
      withoutRegion: () => `${withPlace}/localities`, //add per_page and page_here and load more in listing
    },
    details: '',
    coverImages: id => `${withPlace}/localities/${id}/cover_image`,
  },

  themes: {
    mountainFinder: id => `${withTheme}/mountains?place=${id}`,
  },

  lodge: {
    listings: '',
    details: id => `${withLodge}/${id}`,
    bookLodge: id => `${withLodge}/${id}/bookings`,
    reviews: lodgeId => `reviews/lodgings/${lodgeId}/comments`,
    reply: (lodgeId, commentId) =>
      `reviews/lodgings/${lodgeId}/comments/${commentId}`,
    ratings: lodgeId => `reviews/lodgings/${lodgeId}/ratings`,
    editData: lodgeId => `${withLodge}/${lodgeId}`,
    coverImages: lodgeId => `${withLodge}/${lodgeId}/cover_image`,
  },

  profile: {
    getMyData: `${withUser}/me`,
    getMyInvoices: `${withUser}/invoices/my`,
    getBookings: `${withUser}/bookings`,
    getUserData: userId => `${withUser}/${userId}`,
    getCartItems: () => `${withUser}/bookings/cart`,
    getPurchaseCompletedItems: () => `${withUser}/bookings/purchase-list`,
    getPendingItems: () => `${withUser}/bookings/pending`,
    patchUserData: id => `${withUser}/${id}`,
    reviews: userId => `reviews/${withUser}/${userId}/comments`,
    reply: (userId, commentId) =>
      `reviews/${withUser}/${userId}/comments/${commentId}`,
    ratings: userId => `reviews/${withUser}/${userId}/ratings`,
    getGuideListings: `${withUser}/leaders`,
    newslettersSubscriptions: `${withUser}/newsletters/subscribe`,
    getGuideData: userId => `user/${userId}/guide`,
  },
  admin: {
    getUsers: () => 'users',
    modifyRole: id => `users/${id}/role`,
    verifyGuide: id => `users/${id}/verify`,
    masquerade: id => `users/${id}/masquerade`,
  },
  getBookingDetails: (bookingType, id) => `${bookingType}/bookings/${id}`,
  payment: {
    processId: `${withPayment}/process`,
    hbl: `${withPayment}/complete/hblpay`,
    getInvoice: (invoiceId: string) => `${withPayment}/invoices/${invoiceId}`,
    postInvoice: `${withPayment}/invoices`,
    process: invoiceId => `${withPayment}/process/${invoiceId}`,
    myInvoices: `${withPayment}/invoices/my`,
    createInvoice: `${withPayment}/invoices`,
    verify: `${withPayment}/verify`,
  },
  flights: {
    search: 'flights/search',
    getInvoices: 'payments/invoices',
    createHBLPaymentOrder: invoiceId => `payments/hblpay/${invoiceId}/create`,
    reviews: flightId => `reviews/flights/${flightId}/comments`,
    reply: (userId, commentId) =>
      `reviews/flights/${userId}/comments/${commentId}`,
    ratings: flightId => `reviews/flights/${flightId}/ratings`,
    getInvoiceStatus: invoiceNum => `payments/invoices/${invoiceNum}`,
  },
  notifications: {
    subscribe: 'users/notifications/subscribe',
  },
  invoice: {
    create: 'payments/invoices',
  },
  promoCode: {
    getDiscount: `${withPayment}/promocode/verify`,
  },
};

export default Object.freeze(endpoints);



// WEBPACK FOOTER //
// ./src/lib/endpoints.js